// Components
import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Assets
import SB from "@/assets/icons/header/motivators/SB.svg";

const SpiffBonusAwardsView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Service Spiff Awards",
	headerIcon: SB,
	motivatorType: "spiffBonusAwards",
});

export default SpiffBonusAwardsView;
